// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29PD5","colBig":"styles_colBig__1VaLU","colSmall":"styles_colSmall__2tqxR"};